<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hP1RmU/images/MyCoverImage.jpg?1734367726364" alt="This image is the cover for the book Come the Morning, Graham Clan"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Come the Morning, Graham Clan
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling author begins the Graham Clan series with “a swashbuckling tale of warring factions in 12th-century Scotland” (<i>Publishers Weekly</i>).</b><br/><br/> During a bloody borderland skirmish, thirteen-year-old Waryk de Graham wields his slain father’s sword and vanquishes the Norman enemy. Ten years later, with King Henry I dead and the English succession in chaos, Waryk, the newly knighted Laird Lion, is once again fighting for his Scottish homeland—this time against Normans and Vikings alike. But it is for the heart of one extraordinary woman that the great warrior will wage his fiercest battle.<br/><br/> The daughter of a Gaelic noblewoman and a Viking warlord, proud, independent Lady Mellyora MacAdin of Blue Isle is a formidable swordswoman who yields to no man. When Scotland’s King David decrees that she marry the war-scarred knight Waryk in order to keep the Viking island secure for his kingdom, she defiantly rebels.<br/><br/><i>Come the Morning</i> is the first novel in Heather Graham’s medieval Scottish series that introduces the Graham clan, Gaelic-speaking Lowlanders who fight with their Highland brethren for the country they love.<br/><br/><i>This ebook features an illustrated biography of Heather Graham, including rare photos from the author’s personal collection.</i><br/><br/><b><i>Come the Morning </i>is the 1st book in the Graham Clan series, but you may enjoy reading the series in any order.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heather Graham
      </h2>
      
      <p class="authorDescription body article">Heather Graham (b. 1953) is a bestselling author of more than 150 romance, suspense, and historical novels that have sold seventy-five million copies worldwide. Raised in Florida, Graham went to college for theater arts, and spent several years acting, singing, and bartending before she devoted herself to writing. Her first novel, <i>When Next We Love</i>, was published in 1982. Although she became famous as an author of romance novels, Graham has since branched out into supernatural horror, historical fiction, and suspense, with titles such as <i>Tall, Dark, and Deadly </i>(1999), <i>Long, Lean, and Lethal </i>(2000), and<i> Dying to Have Her </i>(2001). In 2003 the Romance Writers of America, whose Florida chapter Graham founded, granted her a lifetime achievement award. She lives, writes, and scuba dives in Florida with her husband and five children. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ccec870